import React from 'react';
import styled from 'styled-components';

export const WarningCard = () => {
  return (
    <Wrapper>
      <Card>
        <Message>
          <Highlight>EL NOMBRE DEL TITULAR DE LA TARJETA DEBE SER EL MISMO QUE EL NOMBRE DEL TITULAR DE LA CUENTA.</Highlight>
        </Message>
      </Card>

      <Card>
        <Message>
          <Highlight>Te recomendamos depositar utilizando la tarjeta digital con CVV dinamico de tu banco.</Highlight>
        </Message>
        <Divider />
        <Message>
          <Highlight>!Recuerda!</Highlight>{' '}
          <Small>
            En los casos que apliquen, la tarjeta que uses para depositar, sera la tarjeta que
            deberas usar para solicitar un retiro de tus fondos.
          </Small>
        </Message>
      </Card>
    </Wrapper>
  );
};


const Card = styled.div`
  border: 2px solid #d5463d;
  border-radius: 14px;
  background: linear-gradient(180deg, #12161d 0%, #0f1318 100%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
  color: #f5f7fb;
  padding: 18px 22px;
  text-align: center;
`;

const Message = styled.p`
  margin: 0;
  font-family: "Lato", sans-serif;
  font-size: 10px;
  line-height: 1.1;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 18px 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.7) 20%,
    rgba(255, 255, 255, 0.7) 80%,
    rgba(255, 255, 255, 0) 100%
  );
`;

const Highlight = styled.span`
  color: #ffffff;
  font-weight: 600;
`;

const Small = styled.span`
  color: #d4d9e1;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;


export default WarningCard;

